<ng-template #caretIcon let-prop="prop">
  <i
    [ngClass]="
      sortProp() !== prop
        ? 'far fa-caret-up ps-1'
        : sortDir() === 'asc'
          ? 'fas fa-caret-down ps-1'
          : sortDir() === 'desc'
            ? 'fas fa-caret-up ps-1'
            : ''
    "
  ></i>
</ng-template>
<div class="app-container">
  <page-header [icon]="'far-cube'" [title]="'products'">
    <ng-container class="header-button">
      @if (canCreate) {
        <btn
          [routerLink]="['/product']"
          [label]="'product.create'"
          [title]="'product.create' | translate"
          [classes]="['btn-first', 'float-right']"
          [icon]="'far-plus'"
          [dataCyAttribute]="'add-product'"
        ></btn>
      }
      <modal-batch-import-from-file
        class="me-2"
        [suppliers]="querySuppliers.data()"
        [isCreatingProducts]="true"
        [isInProducts]="true"
        (resultBatch)="createBatchFromFile($event)"
      ></modal-batch-import-from-file>
      @if (canCreate) {
        <app-exports #exportsModal [entity]="'products'"></app-exports>
      }
      <btn
        [routerLink]="['/print/inventory-exports']"
        [classes]="['btn-third', 'float-right', 'me-2']"
        [icon]="'far-file-check'"
        [label]="'Inventury'"
        [title]="'Inventury'"
        [dataCyAttribute]="'inventories'"
      ></btn>
    </ng-container>
  </page-header>

  <section class="content">
    <!--    (onSubmit)="queryProducts.refetch({ force: true })"-->
    <app-filter-form
      [filters]="submittedQueryFilters()"
      [filtersForExport]="submittedQueryFilters()"
      [loading]="areCoreDataLoading()"
      [entity]="'products'"
      [totalItems]="totalItems()"
      [filterVisible]="filtersExpanded"
      [allFilters]="filters()"
      [defaultFilters]="defaultFilters"
      [advancedFilterKeys]="advancedFilterKeys"
      (onSubmit)="onFilterSubmit()"
      (onClearClick)="clearFilters()"
      (onExportResult)="queryProducts.refetch({ force: true })"
      (onCreateModalHidden)="exportsModal.showChildModal()"
      [checkedProducts]="checkedProducts"
      [areAllProductsChecked]="areAllProductsChecked"
      [tags]="queryTags.data()"
      [depots]="queryDepotsOptions.data()"
      [isInProducts]="true"
      [isPurchaseOrderShown]="isPurchaseOrderAllowed"
      [isExportButtonShown]="true"
      (setCheckedProductsToFalse)="setCheckedProductsToFalse()"
      (onPurchaseOrderClick)="modalproductPurchase.showChildModal()"
      [checkedMap]="checkedMap"
    >
      <div class="container-fluid ps-0 pe-0">
        <!--      FIRST ROW OF INPUTS-->
        <div class="row mr-0">
          <div class="col-md-4">
            <form-row-input
              [label]="'fulltext'"
              [icon]="null"
              [model]="filters().fulltext"
              (modelChange)="setFilters('fulltext', $event)"
              (keyup.enter)="onFilterSubmit()"
              [dataCyAttribute]="'product-name-filter'"
            ></form-row-input>
          </div>
          <div class="col-md-2">
            <form-row-select-multiple
              [label]="'products.depots'"
              [options]="queryDepotsOptions.data()"
              [selectedValues]="filters().depots"
              (selectedValuesChange)="setFilters('depots', $event)"
              [dataCyAttribute]="'product-depots-filter'"
            ></form-row-select-multiple>
          </div>
          <div class="col-md-2">
            <form-row-select
              [label]="'products.availability'"
              [icon]="null"
              [model]="filters().availability"
              (modelChange)="setFilters('availability', $event)"
              [options]="availabilityTypes"
              [dataCyAttribute]="'product-availability-filter'"
            ></form-row-select>
          </div>
          <div class="col-md-2">
            <form-row-select-multiple
              [label]="'tags'"
              [options]="queryTags.data()"
              [selectedValues]="filters().tags"
              (selectedValuesChange)="setFilters('tags', $event)"
              [isTags]="true"
              [dataCyAttribute]="'product-tags-filter'"
            ></form-row-select-multiple>
          </div>
          <div class="col-12 col-sm-4 col-md-2 col-lg-2 col-xl-2">
            <form-row-select-multiple
              [label]="'tagsNegate'"
              [options]="queryTags.data()"
              [selectedValues]="filters().tagsNegate"
              (selectedValuesChange)="setFilters('tagsNegate', $event)"
              [isTags]="true"
              [dataCyAttribute]="'products-tagsNegate-filter'"
            ></form-row-select-multiple>
          </div>
        </div>
        <div class="custom-dropdown" [ngClass]="{ open: filtersExpanded() }">
          <div class="row mr-0">
            <div class="col-md-1" title="{{ 'product.isBundle.tooltip' | translate }}">
              <form-row-select
                [label]="'product.virtual'"
                [icon]="null"
                [model]="filters().isBundle"
                (modelChange)="setFilters('isBundle', $event)"
                [options]="abilityTypes"
                [dataCyAttribute]="'product-is-bundle-filter'"
              ></form-row-select>
            </div>
            <div class="col-md-1 pe-0">
              <form-row-select
                [label]="'product.enabled'"
                [icon]="null"
                [model]="filters().enabled"
                (modelChange)="setFilters('enabled', $event)"
                [options]="abilityTypes"
                [dataCyAttribute]="'product-enabled-filter'"
              ></form-row-select>
            </div>
            <div class="col-md-2">
              <form-row-input
                [label]="'product.code'"
                [icon]="null"
                [model]="filters().code"
                (modelChange)="setFilters('code', $event)"
                (keyup.enter)="onFilterSubmit()"
                [dataCyAttribute]="'product-code-filter'"
              ></form-row-input>
            </div>
            <div class="col-md-2">
              <form-row-input
                [label]="'ean'"
                [icon]="null"
                [model]="filters().ean"
                (modelChange)="setFilters('ean', $event)"
                (keyup.enter)="onFilterSubmit()"
                [dataCyAttribute]="'product-ean-filter'"
              ></form-row-input>
            </div>
            <div class="col-md-2">
              <form-row-select-multiple
                [label]="'products.suppliers'"
                [options]="querySuppliers.data()"
                [selectedValues]="filters().suppliers"
                (selectedValuesChange)="setFilters('suppliers', $event)"
                [dataCyAttribute]="'product-suppliers-filter'"
              ></form-row-select-multiple>
            </div>
            <div class="col-md-2">
              <form-row-select-multiple
                [label]="'products.producers'"
                [options]="queryProducers.data()"
                [selectedValues]="filters().producers"
                (selectedValuesChange)="setFilters('producers', $event)"
                [dataCyAttribute]="'product-producers-filter'"
              ></form-row-select-multiple>
            </div>
            <div class="col-md-2">
              <form-row-select
                [label]="'expirationDateTo'"
                [icon]="null"
                [model]="selectedExpiration"
                (modelChange)="setExpirationFilter($event)"
                [options]="expirations"
                [dataCyAttribute]="'product-selected-expiration-filter'"
              ></form-row-select>
              <!--              todo error-->
              <!--              todo-->
              @if (selectedExpiration === 'custom') {
                <form-row-input
                  [label]="'expirationDateTo'"
                  [icon]="null"
                  [inputType]="'date'"
                  (modelChange)="setExpirationFilter(null, $event)"
                  [ngModel]="filters().expirationDateTo?.substr(0, 10)"
                  [dataCyAttribute]="'product-expiration-date-filter'"
                ></form-row-input>
              }
            </div>
          </div>
        </div>
        <div class="custom-dropdown" [ngClass]="{ open: filtersExpanded() }">
          <div class="row mr-0">
            <div class="col-md-2 pe-0">
              <form-row-select
                [label]="'product.type'"
                [icon]="null"
                [model]="filters().listType"
                (modelChange)="setFilters('listType', $event)"
                [options]="listTypes"
                [optionKey]="'val'"
                [dataCyAttribute]="'product-list-type-filter'"
              ></form-row-select>
            </div>
            <div class="col-md-4">
              <!--              todo-->
              <app-modal-category-search
                [isForFilterCategories]="true"
                [selectedCategories]="filters().categories"
                (selectedCategoriesChange)="setFilters('categories', $event)"
              >
              </app-modal-category-search>
            </div>
            <div class="col-md-2">
              <form-row-select
                [label]="'products.metrics'"
                [icon]="null"
                [model]="filters().metrics"
                (modelChange)="setFilters('metrics', $event)"
                [options]="purchaseOrdersTypes"
                [dataCyAttribute]="'metrics-filter'"
              ></form-row-select>
            </div>
            <div class="col-md-2">
              <form-row-select
                [label]="'products.hasHsCode'"
                [icon]="null"
                [model]="filters().hasHsCode"
                (modelChange)="setFilters('hasHsCode', $event)"
                [options]="abilityTypes"
                [dataCyAttribute]="'hasHsCode-filter'"
              ></form-row-select>
            </div>
          </div>
        </div>
        <div class="custom-dropdown" [ngClass]="{ open: filtersExpanded() }">
          <div class="row mr-0">
            <div class="col-md-2">
              <form-row-input
                [label]="'products.filter.position1'"
                [icon]="null"
                [model]="filters().position1"
                (modelChange)="setFilters('position1', $event)"
                (keyup.enter)="onFilterSubmit()"
                [dataCyAttribute]="'product-position1-filter'"
              ></form-row-input>
            </div>
            <div class="col-md-2">
              <form-row-input
                [label]="'products.filter.position2'"
                [icon]="null"
                [model]="filters().position2"
                (modelChange)="setFilters('position2', $event)"
                (keyup.enter)="onFilterSubmit()"
                [dataCyAttribute]="'product-position2-filter'"
              ></form-row-input>
            </div>
            <div class="col-md-2">
              <form-row-input
                [label]="'products.filter.position3'"
                [icon]="null"
                [model]="filters().position3"
                (modelChange)="setFilters('position3', $event)"
                (keyup.enter)="onFilterSubmit()"
                [dataCyAttribute]="'product-position3-filter'"
              ></form-row-input>
            </div>
          </div>
        </div>
      </div>
    </app-filter-form>

    <div class="card mb-0 pt-3">
      <div
        class="card-body p-0"
        [ngClass]="{
          h150: areCoreDataLoading() || (loadingFirstPage() && !products().length)
        }"
      >
        <loading-spinner
          [isLoading]="areCoreDataLoading() || loadingFirstPage()"
          [classesString]="'pt-88'"
        ></loading-spinner>
        @if (!loadingFirstPage()) {
          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>
                  <th class="padding-th-checkbox">
                    <form-row-checkbox
                      [isOnProductsPage]="true"
                      [title]="'select.all' | translate"
                      [model]="areAllProductsChecked()"
                      (modelChange)="allProductsCheckedChanged($event)"
                      [dataCySelector]="'all-products-checkbox'"
                    >
                    </form-row-checkbox>
                  </th>
                  @if (isColumnSelected('name')) {
                    <th scope="col" class="cursor-pointer" (click)="sortBy('name')">
                      {{ 'product.name' | translate }}
                      <ng-container *ngTemplateOutlet="caretIcon; context: { prop: 'name' }"></ng-container>
                    </th>
                  }
                  @if (isColumnSelected('availability')) {
                    <th scope="col" class="text-center fixed-column-width">
                      {{ 'products.availability' | translate }}
                    </th>
                  }
                  @if (isColumnSelected('code')) {
                    <th scope="col" class="cursor-pointer text-nowrap d-none d-xl-table-cell" (click)="sortBy('code')">
                      {{ 'product.code' | translate }}
                      <ng-container *ngTemplateOutlet="caretIcon; context: { prop: 'code' }"></ng-container>
                    </th>
                  }
                  @if (isColumnSelected('ean')) {
                    <th scope="col" class="cursor-pointer text-nowrap d-none d-xl-table-cell" (click)="sortBy('ean')">
                      {{ 'product.ean' | translate }}
                      <ng-container *ngTemplateOutlet="caretIcon; context: { prop: 'ean' }"></ng-container>
                    </th>
                  }
                  @if (isColumnSelected('tags')) {
                    <th scope="col" class="text-nowrap d-none d-xl-table-cell">
                      {{ 'product.tag' | translate }}
                    </th>
                  }
                  @if (isColumnSelected('sellPrice')) {
                    <th scope="col" class="cursor-pointer text-nowrap text-end" (click)="sortBy('sellPrice')">
                      {{ 'product.price' | translate }}
                      <ng-container *ngTemplateOutlet="caretIcon; context: { prop: 'sellPrice' }"></ng-container>
                    </th>
                  }
                  @if (isColumnSelected('weight')) {
                    <th scope="col" class="text-nowrap text-end" data-cy="products-weight-header">
                      {{ 'weight' | translate }}
                    </th>
                  }
                  @if (isColumnSelected('created')) {
                    <th scope="col" class="cursor-pointer text-nowrap text-end" (click)="sortBy('created')">
                      {{ 'products.created' | translate }}
                      <ng-container *ngTemplateOutlet="caretIcon; context: { prop: 'created' }"></ng-container>
                    </th>
                  }
                  <th class="fixed-column-width" scope="col">
                    <dropdown
                      data-cy="products-column-settings"
                      class="float-right"
                      [icon]="'far-cog'"
                      [items]="listingColumns() | colSettings: selectedColumns()"
                      [isArrowHidden]="true"
                      [autoClose]="true"
                      [isColSettings]="true"
                      (onResult)="onColumnSettingDropdownClick($event)"
                    ></dropdown>
                  </th>
                </tr>
              </thead>
              @if (!loadingFirstPage() && !products().length) {
                <tbody>
                  <tr>
                    <td colspan="7" class="text-center p-5 border-bottom-0 no-hover">
                      <div class="empty-list">
                        <i class="far fa-sad-tear"></i>
                        <div>
                          {{ 'no.record.found' | translate }}
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              }
              @if (products() && products().length > 0) {
                <ng-container [photoGalleryGroup]="{ index: 1 }">
                  @for (product of products(); track trackByProductId($index, product)) {
                    <tbody>
                      <tr [ngClass]="{ 'disabled-product': !product.enabled }">
                        <td class="padding-td-checkbox">
                          <form-row-checkbox
                            [isOnProductsPage]="true"
                            [model]="product.isChecked"
                            (modelChange)="productWasChecked(product.id, $event)"
                            [cursorPointer]="true"
                            [dataCySelector]="'product-row-checkbox'"
                          >
                          </form-row-checkbox>
                        </td>
                        @if (isColumnSelected('name')) {
                          <td class="ps-1">
                            <div class="flex-gap-10 align-items-center">
                              <div
                                [photoGallery]="product.mainImage?.url"
                                [photoGalleryCaption]="
                                  product.fullName +
                                  '<br>' +
                                  (product.code ? ('home.code' | translate) + product.code : '') +
                                  '<br>' +
                                  (product.ean ? ('home.ean' | translate) + product.ean : '')
                                "
                              >
                                <div class="images-item">
                                  @if (!!product.mainImage?.url?.length && !!product.mainImage?.thumbnails?.length) {
                                    <img
                                      class="images-item-image"
                                      [src]="getThumbUrl(product.mainImage)"
                                      [alt]="product.fullName"
                                    />
                                  }
                                  @if (!product.mainImage?.url?.length || !product.mainImage?.thumbnails?.length) {
                                    <img
                                      class="images-item-image"
                                      [src]="'assets/img/no-image.png'"
                                      [alt]="product.fullName"
                                    />
                                  }
                                </div>
                              </div>
                              <div>
                                <div>{{ product.fullName }}</div>
                                <div class="product-details flex-gap-5 flex-wrap d-xl-none">
                                  @if (product.code && product.code.length > 0) {
                                    <div>
                                      {{ 'product.code' | translate }}:<span> {{ product.code }}</span>
                                    </div>
                                  }
                                  @if (product.ean && product.ean.length > 0) {
                                    <div>
                                      {{ 'product.ean' | translate }}:<span> {{ product.ean }}</span>
                                    </div>
                                  }
                                </div>
                              </div>
                            </div>
                          </td>
                        }
                        @if (isColumnSelected('availability')) {
                          <td class="text-center">
                            @if (!product.children || !product.children.length) {
                              <modal-stock-overview
                                [isCalculatedOfProductDepots]="true"
                                [isSumCalculated]="true"
                                [product]="product"
                                [depots]="queryDepotsOptions.data()"
                                [suppliers]="querySuppliers.data()"
                                [filterDepots]="submittedQueryFilters().depots"
                                [filterPositions]="submittedQueryFilters()"
                                [showPurchaseQuantity]="true"
                              >
                              </modal-stock-overview>
                            }
                            @if (product.children && product.children.length) {
                              -
                            }
                          </td>
                        }
                        @if (isColumnSelected('code')) {
                          <td class="d-none d-xl-table-cell text-nowrap">
                            {{ product.code && product.code.length > 0 ? product.code : '' }}
                          </td>
                        }
                        @if (isColumnSelected('ean')) {
                          <td class="d-none d-xl-table-cell text-nowrap">
                            {{ product.ean && product.ean.length > 0 ? product.ean : '' }}
                          </td>
                        }
                        @if (isColumnSelected('tags')) {
                          <td class="d-none d-xl-table-cell">
                            <div class="container-tags">
                              @for (tag of product.tags; track tag) {
                                <span
                                  class="tag-span"
                                  [ngStyle]="{ 'background-color': tag.color ? tag.color : '#0058FF', color: 'white' }"
                                >
                                  {{ tag.name }}
                                </span>
                              }
                            </div>
                          </td>
                        }
                        @if (isColumnSelected('sellPrice')) {
                          <td
                            [ngClass]="{
                              'text-center': product.children && product.children.length,
                              'text-end': !product.children || !product.children.length
                            }"
                          >
                            @if (!product.children || !product.children.length) {
                              <div class="d-flex flex-column align-items-end">
                                <div class="text-nowrap">
                                  <span
                                    [ngClass]="product.sellPrice !== product.actualSellPrice ? 'price-cross' : ''"
                                    >{{
                                      product.sellPrice | formatPrice: core.services.user?.user?.company?.currency
                                    }}</span
                                  >
                                </div>
                                @if (product.sellPrice !== product.actualSellPrice && product.actualSellPrice != 0) {
                                  @if (product.sellPrice !== product.actualSellPrice) {
                                    <div class="flex-gap-5 price-red">
                                      <div><i class="far fa-arrow-alt-down"></i></div>
                                      <div>
                                        {{
                                          product.sellPrice | formatPrice: core.services.user?.user?.company?.currency
                                        }}
                                      </div>
                                    </div>
                                  }
                                }
                              </div>
                            }
                            @if (product.children && product.children.length) {
                              -
                            }
                          </td>
                        }
                        @if (isColumnSelected('weight')) {
                          <td class="text-end text-nowrap" data-cy="products-weight-cell">
                            @if (product.weight > 0) {
                              {{ product.weight }}&nbsp;kg
                            }
                          </td>
                        }
                        @if (isColumnSelected('created')) {
                          <td class="d-none d-xl-table-cell">
                            {{ product.created ? (product.created | strToDate | date: 'dd.MM.yyyy HH:mm') : '' }}
                          </td>
                        }
                        <td class="text-end pe-1">
                          <div class="flex-gap-5">
                            <div class="d-flex">
                              @if (product.children && product.children.length) {
                                <button
                                  class="btn-third btn-sm"
                                  (click)="toggleCollapse(product.id)"
                                  [title]="'variants' | translate"
                                >
                                  <i class="far fa-arrow-down me-2"></i>
                                  {{ 'variants' | translate }}
                                </button>
                              }
                            </div>
                            <div>
                              <a
                                class="btn-second"
                                [routerLink]="['/product', product.id]"
                                [title]="'open' | translate"
                                data-cy="open-row"
                              >
                                {{ 'open' | translate }}
                                <i class="far fa-chevron-right align-self-center ms-2"></i>
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                    @if (product.children && product.children.length) {
                      <tbody
                        [id]="'collapse_' + product.id"
                        [class.collapse]="!isCollapsed(product.id)"
                        [class.show]="isCollapsed(product.id)"
                      >
                        @for (child of product.children; track trackByProductId($index, child)) {
                          <tr [ngClass]="{ 'disabled-product': !child.enabled }">
                            <td></td>
                            <td class="ps-1">
                              <div class="flex-gap-10 align-items-center">
                                <div
                                  [photoGallery]="child.mainImage?.url"
                                  [photoGalleryCaption]="
                                    child.fullName +
                                    '<br>' +
                                    (child.code ? ('product.code' | translate) + child.code : '') +
                                    '<br>' +
                                    (child.ean ? ' EAN: ' + child.ean : '')
                                  "
                                >
                                  <div class="images-item">
                                    <img
                                      class="images-item-image"
                                      [src]="getThumbUrl(child.mainImage)"
                                      [alt]="child.fullName"
                                    />
                                  </div>
                                </div>
                                <div>
                                  <div class="align-self-center">
                                    {{ child.name }}
                                  </div>
                                  <div class="product-details flex-gap-5 flex-wrap d-xl-none">
                                    @if (child.code && child.code.length > 0) {
                                      <div>
                                        {{ 'product.code' | translate }}:<span> {{ child.code }}</span>
                                      </div>
                                    }
                                    @if (child.ean && child.ean.length > 0) {
                                      <div>
                                        {{ 'product.ean' | translate }}:<span> {{ child.ean }}</span>
                                      </div>
                                    }
                                  </div>
                                </div>
                              </div>
                            </td>
                            <td class="text-center">
                              <modal-stock-overview
                                [isCalculatedOfProductDepots]="true"
                                [isSumCalculated]="true"
                                [product]="child"
                                [depots]="queryDepotsOptions.data()"
                                [suppliers]="querySuppliers.data()"
                                [filterDepots]="submittedQueryFilters().depots"
                                [showPurchaseQuantity]="true"
                              >
                              </modal-stock-overview>
                            </td>
                            <td class="text-start d-none d-xl-table-cell">
                              {{ child.code }}
                            </td>
                            <td colspan="2" class="text-start d-none d-xl-table-cell">
                              {{ child.ean }}
                            </td>
                            <td class="text-end pe-0">
                              <div class="d-flex flex-column align-items-end">
                                <div class="text-nowrap">
                                  <span [ngClass]="child.sellPrice !== child.sellPrice ? 'price-cross' : ''">{{
                                    child.sellPrice | formatPrice
                                  }}</span>
                                </div>
                                @if (child.sellPrice !== child.actualSellPrice && child.actualSellPrice != 0) {
                                  @if (child.sellPrice !== child.actualSellPrice) {
                                    <div class="flex-gap-5 price-red">
                                      <div><i class="far fa-arrow-alt-down"></i></div>
                                      <div>
                                        {{ child.sellPrice | formatPrice: core.services.user?.user?.company?.currency }}
                                      </div>
                                    </div>
                                  }
                                }
                              </div>
                            </td>
                            @if (isColumnSelected('weight')) {
                              <td class="text-end text-nowrap" data-cy="products-weight-cell">
                                @if (child.weight > 0) {
                                  {{ child.weight }}&nbsp;kg
                                }
                              </td>
                            }
                            <td colspan="2" class="text-end">
                              <div>
                                <a
                                  [routerLink]="['/product', child.id]"
                                  class="btn-second btn-sm float-right ms-2"
                                  [title]="'open' | translate"
                                >
                                  {{ 'open' | translate }}
                                  <i class="far fa-chevron-right ms-2"></i>
                                </a>
                              </div>
                            </td>
                          </tr>
                        }
                      </tbody>
                    }
                  }
                </ng-container>
              }
            </table>
            @if (nextButtonShow()) {
              <app-pagination-btn (switchPage)="queryProducts.fetchNextPage()" [loadingPage]="loadingNextPage()">
              </app-pagination-btn>
            }
          </div>
        }
      </div>
    </div>
  </section>
</div>
<modal-product-purchase
  #modalproductPurchase
  (result)="redirect($event)"
  [depots]="queryDepotsOptions.data()"
></modal-product-purchase>
